const initialKeysState = {
    loading: false,
    error: null,
    keys: {}
};

export const fetchKeysRequest = () => ({ type: 'FETCH_KEYS_REQUEST' });

export const fetchKeysSuccess = (keys) => ({
    type: 'FETCH_KEYS_SUCCESS',
    payload: keys
});
export const fetchKeysFailure = (error) => ({
    type: 'FETCH_KEYS_FAILURE',
    payload: error
});

export const keysReducer = (state = initialKeysState, action) => {
    switch (action.type) {
        case 'FETCH_KEYS_REQUEST':
            return { ...state, loading: true, error: null };
        case 'FETCH_KEYS_SUCCESS':
            return {
                ...state,
                loading: false,
                keys: action.payload,
                error: null
            };
        case 'FETCH_KEYS_FAILURE':
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
